<template>
  <div>
    <v-avatar
      :min-width="size"
      :width="size"
      :height="size"
      large
      color="white"
      class="user-avatar"
      >
      <v-img
      :width="size"
      :height="size"
      :src="getAvatarUrl(email || $store.state.home.user.email, size)"
      ></v-img>
    </v-avatar>
    <v-badge
      :value="badge"
      :color="badge"
      bordered
      bottom
      dot

      class="user-dot-badge"
    >
    </v-badge>
  </div>
</template>

<script>
import { getAvatarUrl } from "@/apis/HelperFunctions";

export default {
  data() {
    return {
      getAvatarUrl,
    };
  },
  props: {
    size: {
      type: Number,
      default: 48,
    },
    email: {
      type: String,
      default: "",
    },
    badge: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.v-avatar {
  border-color: var(--v-gray-lighten2) !important;
  border-style: solid !important;
  border-width: 1px !important;
}
.user-dot-badge{
  position: absolute;
  bottom: 12px;
  right: 45px;
  .v-badge.v-badge--dot .v-badge__badge{
    width: 10px;
    height: 10px;
    &:after{
      border-width: 1px;
    }
  }
}
 
</style>
